const LINKS = [
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/seva_naturii/',
    icon: (
      <>
        <rect x="3" y="3" width="18" height="18" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="0.6" fill="currentColor" stroke="none" />
      </>
    ),
  },
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/seva.naturalcosmetics/',
    icon: <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />,
  },
]

export function SocialLinks() {
  return (
    <ul className="flex items-center gap-5">
      {LINKS.map(({ label, href, icon }) => (
        <li key={label}>
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            title={label}
            className="grid size-12 place-items-center rounded-full border border-(--color-forest)/30 text-(--color-forest) transition hover:border-(--color-forest) hover:bg-(--color-forest) hover:text-(--color-cream) focus-visible:ring-4 focus-visible:ring-(--color-forest)/25 focus-visible:outline-none"
          >
            <svg
              viewBox="0 0 24 24"
              aria-hidden="true"
              className="size-6"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              {icon}
            </svg>
          </a>
        </li>
      ))}
    </ul>
  )
}
